/* Swiper init for the ORCA product carousel. The design has no arrows or dots —
   the slider only exists so more products than fit can be swiped through. */
(() => {
  const init = (root) => {
    root.querySelectorAll('.product-carousel__slider').forEach((el) => {
      if (el.swiper) return;
      // the gap is declared in CSS as `column-gap` (which has no effect on the
      // Swiper container itself) purely so it resolves to pixels here
      const gap = () => parseFloat(getComputedStyle(el).columnGap) || 0;
      const swiper = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: gap(),
        // the design centres the row when the products do not fill it
        centerInsufficientSlides: true,
        watchOverflow: true,
      });
      window.addEventListener('resize', () => {
        swiper.params.spaceBetween = gap();
        swiper.update();
      });
    });
  };

  const start = () => init(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
